import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ReactSound from 'react-sound';
import UIFx from 'uifx';
import styled, { css, keyframes } from 'styled-components';
import { bossDefeated } from '../../actions/learn-fight';
import { useImagesContext } from '../../contexts/ImagesContext';
import { getTwilightZoneOfStudent } from '../../services/twilight_zone';
import { getImageUrl } from '../../utils/image';
import Loading from '../layout/Loading';
import { ImgClick } from '../utility';
import bossClearSound from './sounds/boss-clear.mp3';
import backgroundSound from './sounds/background.mp3';

const TwilightZoneStage = ({
  student,
  twilightZoneId,
  handleBack,
  handleStageSelected,
  stageCompletedValue,
  bossDefeatedValue,
  bossDefeated,
  config,
  searchPower,
}) => {
  const { images } = useImagesContext();
  const [twilightZone, setTwilightZone] = useState(null);
  const [notSearchPower, setNotSearchPower] = useState(false);
  const [notFightingPower, setNotFightingPower] = React.useState(false);

  async function loadData() {
    console.log('twilightZoneId', twilightZoneId);
    const retTwilightZoneOfStudent = await getTwilightZoneOfStudent(
      student.id,
      twilightZoneId
    );
    console.log('getTwilightZoneOfStudent', retTwilightZoneOfStudent.data);
    setTwilightZone(retTwilightZoneOfStudent.data);
  }

  useEffect(() => {
    loadData();
    if (bossDefeatedValue) {
      setTimeout(() => {
        bossDefeated(null);
      }, 5000);
    }
  }, []);

  console.debug('bossDefeatedValue', bossDefeatedValue);
  console.debug('twilightZone:stage:searchPower', searchPower);

  function getStageVideo(stage) {
    return (
      <>
        <StageBlock
          key={stage.id}
          top={stage.imageTop}
          left={stage.imageLeft}
          $canClick={stage.canAccess === true}
          onClick={() => {
            if (stage.canAccess === true) {
              if (searchPower === 0) {
                setNotSearchPower(true);
                setTimeout(() => {
                  setNotSearchPower(false);
                }, 3000);
              } else {
                handleStageSelected(stage, twilightZone);
              }
            }
          }}
        >
          <StageVideo
            $display={stage.isPass === false}
            src={
              stage.image
                ? getImageUrl(stage.image)
                : images['image-default.png']
            }
          />
          <Title>{stage.title}</Title>
        </StageBlock>
        {/* <Cicle top={stage.imageTop} left={stage.imageLeft} /> */}
      </>
    );
  }

  function getStageBoss(stage) {
    return (
      <>
        <StageBlock
          key={stage.id}
          top={stage.imageTop}
          left={stage.imageLeft}
          $canClick={stage.canAccess === true && stage.isPass === false}
          onClick={() => {
            if (stage.canAccess === true && stage.isPass === false) {
              if (student.powerType === null) {
                setNotFightingPower(true);
                setTimeout(() => {
                  setNotFightingPower(false);
                }, 3000);
                return;
              }
              handleStageSelected(stage, twilightZone);
            }
          }}
        >
          <StageBoss
            $pass={stage.isPass}
            $clear={
              bossDefeatedValue !== null &&
              stage.id === bossDefeatedValue.stageId
            }
            src={
              stage.image
                ? getImageUrl(stage.image)
                : images['image-default.png']
            }
          />
          {bossDefeatedValue !== null &&
            stage.id === bossDefeatedValue.stageId && (
              <>
                {config.isMutedSound === false && (
                  <ReactSound
                    url={bossClearSound}
                    playStatus="PLAYING"
                    loop={false}
                  ></ReactSound>
                )}
              </>
            )}
        </StageBlock>
        {/* <Cicle top={stage.imageTop} left={stage.imageLeft} /> */}
      </>
    );
  }

  return (
    <Container>
      {twilightZone && (
        <>
          <Background src={getImageUrl(twilightZone.background)} alt="" />
          {twilightZone.stages.map((stage) => (
            <>
              {stage.canAccess && !stage.isPass && (
                <Walk
                  left={stage.walkLeft}
                  top={stage.walkTop}
                  src={images['walk.png']}
                />
              )}
              {stage.stageType === 'video' && getStageVideo(stage)}
              {stage.stageType === 'boss' && getStageBoss(stage)}
            </>
          ))}
          {notSearchPower && (
            <CenterImage src={images['not-search-power.png']} />
          )}
          <Home src={images['home.png']} onClick={handleBack} alt="back" />;
        </>
      )}
      {!twilightZone && <Loading />}
      {notFightingPower && (
        <CenterImage src={images['not-fighting-power.png']} alt="" />
      )}
      <ReactSound
        url={backgroundSound}
        playStatus="PLAYING"
        loop={true}
        volume={config.isMutedSound ? 0 : 100}
      ></ReactSound>
    </Container>
  );
};

const CenterImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Container = styled.div`
  width: 1920px;
  height: 1080px;
  position: relative;
`;

const Background = styled.img`
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  position: absolute;
  object-fit: contain;
`;

const Home = styled(ImgClick)`
  position: absolute;
  top: 16px;
  left: 16px;
`;

const Walk = styled.img`
  position: absolute;
  left: ${(props) => props.left}px;
  top: ${(props) => props.top}px;
`;

// const Cicle = styled.span`
// position: absolute;
// top: ${(props) => props.top}px;
// left: ${(props) => props.left}px;
// height: 12px;
// width: 12px;
// background-color: yellow;
// border-radius: 50%;
// display: inline-block;
// transform: translate(-50%, -50%);
// }

// const StageBlock = styled.div`;
//   position: absolute;
//   top: ${(props) => props.top}px;
//   left: ${(props) => props.left}px;
//   transform: translate(-50%, -50%);
// `;

const StageBlock = styled.div`
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  &:hover {
    filter: ${(props) =>
      props.$canClick ? 'drop-shadow(0px 4px 4px black)' : ''};
    transform: ${(props) => (props.$canClick ? 'scale(1.06)' : '')};
  }
`;

const StageVideo = styled.img`
  // position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  opacity: ${(props) => (props.$display ? 1 : 0)};
`;

const StageBoss = styled.img`
  ${(props) => {
    if (props.$pass && props.$clear) {
      return css`
        position: absolute;
        opacity: 0.2;
        animation: ${fadeOut} 3s ease-in;
      `;
    } else if (props.$pass) {
      return css`
        position: absolute;
        opacity: 0.2;
      `;
    }
    return css`
      position: absolute;
      opacity: 1;
    `;
  }}
`;
// animation: ${fadeOut} 3s ease-in;

const BossClear = styled.img`
  position: absolute;
  // transform: translate(50%, 50%);
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
`;

const Title = styled.div`
  // position: relative;
  margin-top: -60px;
  font-family: 'PSLxText';
  color: white;
  font-weight: bold;
  font-size: 30px;
  -webkit-text-stroke: 0.05em black;
  paint-order: stroke fill;
  text-align: center;
  // width: 250px;
  // border: 3px solid black;
`;

// export default TwilightZoneStage;

const mapStateToProps = ({ learnFight, config }) => ({
  config,
  // questions: learnFight.questions,
  bossDefeatedValue: learnFight.bossDefeatedValue,
  stageCompletedValue: learnFight.stageCompletedValue,
  searchPower: learnFight.searchPower,
});

const mapDispatchToProps = {
  bossDefeated,
};

export default connect(mapStateToProps, mapDispatchToProps)(TwilightZoneStage);
